import { FormBase } from 'core/components';

export default class ReturnAddressForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'seller',
					label: 'RETURNADDRESSFORM.SELLER',
				},
				{
					name: 'name',
					label: 'RETURNADDRESSFORM.NAME',
					rules: 'required',
				},
				{
					name: 'country',
					label: 'RETURNADDRESSFORM.COUNTRY',
					rules: 'required',
				},
				{
					name: 'state',
					label: 'RETURNADDRESSFORM.STATE',
					rules: 'required',
				},
				{
					name: 'address',
					fields: [
						{
							name: 'address1',
							label: 'RETURNADDRESSFORM.ADDRESS1',
							rules: 'required',
						},
						{
							name: 'address2',
							label: 'RETURNADDRESSFORM.ADDRESS2',
						},
						{
							name: 'address3',
							label: 'RETURNADDRESSFORM.ADDRESS3',
						},
						{
							name: 'city',
							label: 'RETURNADDRESSFORM.CITY',
							rules: 'required',
						},
						{
							name: 'zipCode',
							label: 'RETURNADDRESSFORM.ZIPCODE',
							rules: 'required',
						},
					],
				},
				{
					name: 'isDefaultReturnAddress',
					label: 'RETURNADDRESSFORM.ISDEFAULTRETURNADDRESS',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/return-address/forms/ReturnAddressForm.js